import { createFrontendModule, AppRootElementBlueprint } from '@backstage/frontend-plugin-api';
import { TopAlertDisplay } from '../components/Root/TopAlertDisplay';

/** Positions global alerts below the fixed top nav. */
export const alertDisplayModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    AppRootElementBlueprint.makeWithOverrides({
      name: 'alert-display',
      factory(originalFactory) {
        return originalFactory({
          element: <TopAlertDisplay transientTimeoutMs={3000} />,
        });
      },
    }),
  ],
});

export default alertDisplayModule;
